import currencies from "@/consts/currencies"

export default (
  sum: number | string = 0,
  integer: boolean = false,
  countryCode: string = "uk"
): string => {
  const formatedSum = new Intl.NumberFormat(countryCode, {
    minimumFractionDigits: integer ? 0 : 2,
    maximumFractionDigits: integer ? 0 : 2
  }).format(+sum)

  return formatedSum + " " + currencies[countryCode].label
}
